/* Client guidance only; the original native multipart form owns transmission.
   No undocumented line-item upload byte/pixel limit is imposed here. */
(function () {
  'use strict';
  var tvT=function(value){return window.TilvyI18n?window.TilvyI18n.t(value):value;};
  if (window.TilvyPersonalizationValidation) {
    window.TilvyPersonalizationValidation.init(document);
    return;
  }
  var months = [
    ['Januar', 'jan'], ['Februar', 'feb'], ['März', 'mär', 'mrz', 'maerz', 'maer'],
    ['April', 'apr'], ['Mai'], ['Juni', 'jun'], ['Juli', 'jul'], ['August', 'aug'],
    ['September', 'sep', 'sept'], ['Oktober', 'okt'], ['November', 'nov'], ['Dezember', 'dez']
  ];
  var monthNames = Object.create(null);
  months.forEach(function (names) {
    names.forEach(function (name) { monthNames[name.toLocaleLowerCase('de-DE')] = names[0]; });
  });
  var isFrench = Boolean(window.TilvyI18n && window.TilvyI18n.locale === 'fr');
  if (isFrench) {
    var frenchMonths = [['janvier','janv'],['février','fevrier','févr','fevr'],['mars'],['avril','avr'],['mai'],['juin'],['juillet','juil'],['août','aout'],['septembre'],['octobre','oct'],['novembre'],['décembre','decembre','déc','dec']];
    frenchMonths.forEach(function (aliases, index) {
      aliases.forEach(function (alias) { monthNames[alias] = months[index][0]; });
    });
  }
  function parseMonths(value, min, max) {
    var text = value.trim().normalize('NFC');
    var countMessage = min === max
      ? tvT('Bitte gib genau ') + min + tvT(' Geburtsmonate ein, z. B. Mai und August.')
      : tvT('Bitte gib ') + min + tvT(' bis ') + max + tvT(' Geburtsmonate ein, getrennt durch Kommas.');
    if (!text) return { months: [], error: countMessage };
    var tokens = text.split(isFrench ? /\s*(?:[,;\n\/&]|\bund\b|\bet\b)\s*/i : /\s*(?:[,;\n\/&]|\bund\b)\s*/i);
    var parsed = tokens.map(function (token) {
      return monthNames[token.trim().toLocaleLowerCase('de-DE').replace(/\.$/, '')];
    });
    if (parsed.some(function (month) { return !month; })) {
      return { months: [], error: tvT('Bitte verwende gültige deutsche Monatsnamen, z. B. Mai, August oder Jan. Trenne die Monate durch Kommas oder „und“.') };
    }
    if (parsed.length < min || parsed.length > max) return { months: [], error: countMessage };
    return { months: parsed, error: '' };
  }
  function errorNode(input) {
    var field = input.closest('.tv-perso__feld');
    if (!field) return null;
    var node = field.querySelector('[data-tv-fehler]');
    if (!node) {
      node = document.createElement('span');
      node.className = 'tv-perso__fehler';
      node.dataset.tvFehler = '';
      node.id = input.id + '-validation';
      node.setAttribute('role', 'alert');
      field.appendChild(node);
    }
    var ids = (input.getAttribute('aria-describedby') || '').split(/\s+/).filter(Boolean);
    if (ids.indexOf(node.id) === -1) ids.push(node.id);
    input.setAttribute('aria-describedby', ids.join(' '));
    return node;
  }
  function showError(input) {
    var valid = input.disabled || input.validity.valid;
    var field = input.closest('.tv-perso__feld');
    if (field) field.classList.toggle('is-fehler', !valid);
    input.setAttribute('aria-invalid', valid ? 'false' : 'true');
    var node = errorNode(input);
    if (node) node.textContent = valid ? '' : input.validationMessage;
  }
  function updatePreview(input, result) {
    var block = input.closest('[data-tv-perso]');
    var preview = block && block.querySelector('[data-tv-stone-preview]');
    if (!preview) return;
    var list = preview.querySelector('[data-tv-stone-preview-list]');
    var empty = preview.querySelector('[data-tv-stone-preview-empty]');
    if (!list || !empty) return;
    list.replaceChildren();
    preview.hidden = !input.value.trim();
    empty.hidden = result.months.length > 0;
    empty.textContent = result.error || tvT('Trage unten bis zu acht Monate ein, getrennt durch Kommas.');
    result.months.forEach(function (month, index) {
      var legend = Array.from(block.querySelectorAll('[data-tv-stone-month]')).find(function (item) {
        return item.dataset.tvStoneMonth === month;
      });
      if (!legend) return;
      var item = document.createElement('span');
      item.className = 'tv-stone-preview__item';
      var gem = document.createElement('span');
      gem.className = 'tv-stone-preview__gem';
      gem.setAttribute('aria-hidden', 'true');
      gem.style.setProperty('--tv-stone-color', legend.dataset.tvStoneColor);
      var label = document.createElement('span');
      label.textContent = (index + 1) + '. ' + tvT(month) + ' · ' + tvT(legend.dataset.tvStoneName);
      item.append(gem, label);
      list.appendChild(item);
    });
  }
  function fileKind(file) {
    var mime = (file.type || '').toLowerCase();
    var ext = (file.name || '').split('.').pop().toLowerCase();
    if (mime && mime !== 'application/octet-stream' && mime.indexOf('image/') !== 0) return '';
    if (mime.indexOf('image/') === 0) return mime.slice(6);
    var extensions = { jpg: 'jpeg', jpeg: 'jpeg', png: 'png', webp: 'webp', gif: 'gif', svg: 'svg+xml', avif: 'avif', heic: 'heic', heif: 'heif', tif: 'tiff', tiff: 'tiff', bmp: 'bmp', ico: 'x-icon' };
    return extensions[ext] || '';
  }
  function inspectPhoto(file) {
    if (!file || !file.size) return Promise.resolve(tvT('Die Datei ist leer. Bitte wähle ein Foto aus.'));
    var kind = fileKind(file);
    if (!kind) return Promise.resolve(tvT('Bitte wähle eine Bilddatei aus, z. B. JPG, PNG oder WebP.'));
    // These formats have established native browser decoders. An unsupported
    // HEIC/AVIF/TIFF codec is not evidence that a customer's image is damaged.
    var mustDecode = /^(jpeg|jpg|pjpeg|png|x-png|webp|gif|svg\+xml|bmp|x-ms-bmp)$/.test(kind);
    return new Promise(function (resolve) {
      var objectURL;
      try { objectURL = URL.createObjectURL(file); }
      catch (error) { resolve(''); return; }
      var image = new Image();
      var finished = false;
      var timer = setTimeout(function () {
        finish(tvT('Die Bildprüfung dauert zu lange. Bitte wähle dein Foto erneut aus oder exportiere es als JPG oder PNG.'));
      }, 15000);
      function finish(error) {
        if (finished) return;
        finished = true;
        clearTimeout(timer);
        URL.revokeObjectURL(objectURL);
        image.onload = image.onerror = null;
        resolve(error);
      }
      image.onload = function () {
        finish(image.naturalWidth > 0 && image.naturalHeight > 0 ? '' : tvT('Dieses Bild lässt sich nicht lesen. Bitte wähle eine andere Bilddatei.'));
      };
      image.onerror = function () {
        finish(mustDecode ? tvT('Dieses Bild lässt sich nicht lesen. Bitte exportiere es erneut als JPG oder PNG und wähle es noch einmal aus.') : '');
      };
      image.src = objectURL;
    });
  }
  function initPhoto(input) {
    var currentFile;
    var revision = 0;
    var status = '';
    function validate() {
      var file = input.files && input.files[0];
      if (input.disabled) { input.setCustomValidity(''); input.removeAttribute('aria-busy'); return; }
      if (file === currentFile && status) { input.setCustomValidity(status === 'valid' ? '' : status); return; }
      currentFile = file;
      var version = ++revision;
      if (!file) {
        input.removeAttribute('aria-busy');
        status = input.required ? tvT('Bitte wähle das Foto für dein Schmuckstück aus.') : 'valid';
        input.setCustomValidity(status === 'valid' ? '' : status);
        return;
      }
      status = tvT('Dein Foto wird geprüft. Bitte warte einen Moment.');
      input.setCustomValidity(status);
      input.setAttribute('aria-busy', 'true');
      inspectPhoto(file).then(function (error) {
        if (version !== revision || (input.files && input.files[0]) !== file) return;
        status = error || 'valid';
        input.setCustomValidity(input.disabled ? '' : error);
        input.removeAttribute('aria-busy');
        showError(input);
      });
    }
    input.tvValidate = validate;
    input.addEventListener('change', validate);
    input.addEventListener('input', validate);
    input.addEventListener('invalid', function () { validate(); showError(input); });
    validate();
  }
  function init(root) {
    var blocks = Array.from(root.querySelectorAll('[data-tv-perso], [data-tv-perso-fallback]'));
    if (root.matches && root.matches('[data-tv-perso], [data-tv-perso-fallback]')) blocks.unshift(root);
    blocks.forEach(function (block) {
      if (block.dataset.tvValidationReady === '1') return;
      block.dataset.tvValidationReady = '1';
      var inputs = Array.from(block.querySelectorAll('.tv-perso__in'));
      inputs.forEach(function (input) {
        if (input.type === 'file') initPhoto(input);
        if (!input.hasAttribute('data-tv-months-min')) return;
        function validate() {
          if (input.disabled) { input.setCustomValidity(''); return; }
          var result = parseMonths(input.value, Number(input.dataset.tvMonthsMin), Number(input.dataset.tvMonthsMax));
          input.setCustomValidity(result.error);
          updatePreview(input, result);
        }
        input.tvValidate = validate;
        input.addEventListener('input', validate);
        input.addEventListener('change', validate);
        input.addEventListener('blur', function () { validate(); showError(input); });
        validate();
      });
      // invalid does not bubble, and form-associated fields need not be DOM
      // descendants of their form. Capture on the actual field root instead.
      block.addEventListener('invalid', function (event) {
        var input = event.target;
        if (!input.matches('.tv-perso__in')) return;
        if (input.tvValidate) input.tvValidate();
        showError(input);
        var first = inputs.find(function (field) { return !field.disabled && !field.validity.valid; });
        if (input === first) {
          try { input.scrollIntoView({ block: 'center', behavior: 'auto' }); } catch (error) {}
        }
      }, true);
      var bound = inputs.find(function (input) { return input.form; });
      var form = bound && bound.form;
      if (form && isFrench) form.addEventListener('formdata', function (event) {
        if (!block.isConnected || !form.isConnected) return;
        inputs.forEach(function (input) {
          if (!input.isConnected || input.form !== form || input.disabled || !input.name || !input.hasAttribute('data-tv-months-min')) return;
          var parsed = parseMonths(input.value, Number(input.dataset.tvMonthsMin), Number(input.dataset.tvMonthsMax));
          if (!parsed.error) event.formData.set(input.name, parsed.months.join(', '));
        });
      });
      if (form) form.addEventListener('submit', function (event) {
        // The editor/Section Store can replace this field section while the
        // separate product form survives. Detached or reassigned controls
        // must never veto purchases through that surviving form.
        if (!block.isConnected || !form.isConnected) return;
        var liveInputs = inputs.filter(function (input) {
          return input.isConnected && input.form === form && block.contains(input);
        });
        liveInputs.forEach(function (input) { if (input.tvValidate) input.tvValidate(); });
        var first = liveInputs.find(function (input) { return !input.disabled && !input.validity.valid; });
        if (first) {
          event.preventDefault();
          event.stopImmediatePropagation();
          first.reportValidity();
        }
      }, true);
    });
  }
  window.TilvyPersonalizationValidation = { init: init, parseMonths: parseMonths, inspectPhoto: inspectPhoto };
  init(document);
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
})();
